export default new class Map {
    constructor() {

    }

    createMaps(selector, cord, zoom, title, text) {
        ymaps.ready(() => {
            let myMap = new ymaps.Map(selector, {
                center: cord,
                zoom: zoom || 16,
                controls: ['zoomControl']
            }, {
                searchControlProvider: 'yandex#search'
            });

            myMap.behaviors.disable('scrollZoom');

            this.createPlacemark(myMap, cord, title, text );
        });
    }

    createPlacemark(map, cord, title, text) {
        let myPlacemark = new ymaps.Placemark(cord, {
            balloonContentHeader: title ,
            balloonContentBody: text,
            mapAutoPan: true
        }, {
            preset: 'islands#redIcon',
            balloonPanelMaxMapArea: $('body').hasClass('mobile') ? Infinity : 0
        });

        //add placemark
        map.geoObjects.add(myPlacemark);
        //open baloon
        myPlacemark.balloon.open();
    }
};
